import { Button, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PasswordRecovery } from 'services/RecoveryPassword';
import { passwordRule } from 'utils/forms/validationRules';
import { RecoveryPhoneFormWrapper } from '../style';

function RecoveryPasswordForm({ setCurrentStep, setFormData, formData }) {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const onSubmit = async ({ password }) => {
    try {
      const payload = {
        mobile_phone: formData.mobile_phone,
        encoded_hash: formData.encoded_hash,
        new_password: password,
        is_crm_user: true,
      };
      const res = await PasswordRecovery.changePassword(payload);
      if (res) {
        navigate('/login');
        setCurrentStep(0);
        setFormData({});
        message.success('Пароль успешно изменён');
      } else {
        message.error('Не получилось изменить пароль');
      }
    } catch (err) {
      message.error('Что-то пошло не так. Попробуйте еще раз', 2);
    }
  };

  return (
    <RecoveryPhoneFormWrapper>
      <Form
        form={form}
        onFinish={onSubmit}
        layout="horizontal"
        requiredMark={false}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 24,
        }}
      >
        <h4>Воссстановление пароля</h4>

        <div className="login-form">
          <div className="login-form__inputs">
            <Form.Item name="password" label="Пароль" rules={passwordRule}>
              <Input.Password placeholder="Введите пароль" />
            </Form.Item>

            <Form.Item
              name="confirm"
              label="Повторите:"
              dependencies={['password']}
              rules={[
                {
                  required: true,
                  message: 'Повторите пароль!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('Пароли должны совпадать!')
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Повторите пароль" />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
            >
              <Button type="primary" htmlType="submit">
                Отправить
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </RecoveryPhoneFormWrapper>
  );
}

export { RecoveryPasswordForm };
